
import { getFirestore, collection, 
  doc, query, where,getDocs
} from "firebase/firestore";
import{app} from "../firebase/data"




// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const booksRef = collection(db, "books");

export async function getBooksList (){
    const  querySnapshot = await getDocs(booksRef);
    //console.log("It´s QuerySnapShot: "+querySnapshot);
    //console.log("It´s QuerySnapShot.docs: "+querySnapshot.docs);

  const booksList=querySnapshot.docs.map(doc => {
    return {...doc.data(),id:doc.id}

    })
    return booksList;
}

